/**
 * HeroMinimal Schema
 * Schema-driven settings with conditional visibility
 */
const gradientOptions = [
  { value: 'blue-purple', label: 'Синий-фиолетовый' },
  { value: 'green-teal', label: 'Зелёный-бирюзовый' },
  { value: 'orange-red', label: 'Оранжевый-красный' },
  { value: 'dark-blue', label: 'Тёмно-синий' },
  { value: 'sunset', label: 'Закат' },
  { value: 'ocean', label: 'Океан' },
  { value: 'midnight', label: 'Полночь' },
  { value: 'custom', label: 'Свой градиент' }
];

export default {
  id: 'herominimal',
  version: 1,
  title: 'Hero: минималистичный',
  description: 'Минималистичный hero-блок: крупный текст на цветном или градиентном фоне',
  icon: 'Type',
  category: 'hero',

  // Hero секции используют min-height, padding не применяется
  'x-styles': {
    paddingTop: 0,
    paddingBottom: 0
  },

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Введите заголовок',
          defaults: { size: '5xl', weight: 'bold', color: 'white' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Введите описание',
          multiline: true,
          rows: 3,
          defaults: { size: 'xl', weight: 'normal', color: 'white-muted' }
        }
      ]
    },
    {
      group: 'Фон',
      fields: [
        {
          key: 'backgroundType',
          type: 'select',
          label: 'Тип фона',
          options: [
            { value: 'solid', label: 'Сплошной цвет' },
            { value: 'gradient', label: 'Градиент' }
          ]
        },
        {
          key: 'gradientPreset',
          type: 'select',
          label: 'Градиент',
          mode: 'grid',
          columns: 2,
          visible: (data) => data?.backgroundType === 'gradient',
          options: gradientOptions
        },
        {
          key: 'customGradient',
          type: 'input',
          label: 'CSS градиент',
          placeholder: 'linear-gradient(135deg, #667eea, #764ba2)',
          visible: (data) => data?.backgroundType === 'gradient' && data?.gradientPreset === 'custom'
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'alignment',
          type: 'select',
          label: 'Выравнивание',
          options: [
            { value: 'left', icon: 'AlignLeft' },
            { value: 'center', icon: 'AlignCenter' },
            { value: 'right', icon: 'AlignRight' }
          ]
        },
        {
          key: 'height',
          type: 'select',
          label: 'Высота',
          mode: 'grid',
          columns: 2,
          options: [
            { value: 'small', label: 'Маленькая' },
            { value: 'medium', label: 'Средняя' },
            { value: 'large', label: 'Большая' },
            { value: 'fullscreen', label: 'На весь экран' }
          ]
        }
      ]
    },
    {
      group: 'Кнопки',
      fields: [
        {
          key: 'buttons',
          type: 'buttonList',
          label: 'Кнопки действий',
          variants: ['primary', 'outline']
        }
      ]
    }
  ],

  default: {
    title: { text: 'Просто. Быстро. Эффективно.' },
    subtitle: { text: 'Создавайте современные сайты за считанные минуты' },
    backgroundType: 'gradient',
    gradientPreset: 'blue-purple',
    alignment: 'center',
    height: 'medium',
    buttons: [
      { id: '1', text: 'Попробовать', variant: 'primary', link: '#' }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      if (typeof migrated.title === 'string') {
        migrated.title = { text: migrated.title };
      }
      if (typeof migrated.subtitle === 'string') {
        migrated.subtitle = { text: migrated.subtitle };
      }
      return migrated;
    }
    return data;
  }
};
